import i18n from 'src/i18n';
export let userConstants = {
  customerUsers: {
    apiKeys: {
      facilityName: "facilityName",
      facilityAddress: "facilityAddress",
      parentFacility: "parentFacility",
    },
    countText: " " + i18n.t('people'),
    addNewUserText: " " + i18n.t('addNewAdminText'),
    searchPlaceholderText: i18n.t('searchPlaceholderText'),

  },

  accountUsers: {
    apiKeys: {
      facilityName: "facilityName",
      facilityAddress: "facilityAddress",
      parentFacility: "parentFacility",
    },
    countText: " " + i18n.t('people'),
    addNewUserText: " " + i18n.t('addNewMemberText'),
    searchPlaceholderText: i18n.t('searchPlaceholderText'),
    tableBtnIcon: "",
    tableBtnText: i18n.t('manageText'),
  }
};

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  userConstants.customerUsers.countText = " " + i18n.t('people');
  userConstants.customerUsers.addNewUserText = " " + i18n.t('addNewAdminText');
  userConstants.customerUsers.searchPlaceholderText = i18n.t('searchPlaceholderText');

  userConstants.accountUsers.countText = " " + i18n.t('people');
  userConstants.accountUsers.addNewUserText = " " + i18n.t('addNewMemberText');
  userConstants.accountUsers.searchPlaceholderText = i18n.t('searchPlaceholderText');
  userConstants.accountUsers.tableBtnText = i18n.t('manageText');
}
